export default __webpack_public_path__ + "static/media/TIWAP_Hard.dc60939a.md";